import React,{useEffect, useState,useContext} from 'react'
import SharedDataContext from "../../_helper/SharedData";
import {
    showAlert,
} from "../../Services/Shared.service";
import { Breadcrumbs, Btn, H6 } from "../../AbstractElements";
import { Row, Col, Card, CardBody, Container, Modal, ModalBody, Nav, NavItem, NavLink } from "reactstrap";
import { getPackage, getPackageRate, getPackageRatesList, getPackagesList, getPackagesListBySearch, getPackagesRateListBySearch } from "../../Services/Packages.service";
import { Plus } from "react-feather";
// import PackagesRateTable from "./PackagesRateTable";
// import SearchTable from "../Common/Component/SearchTable";
// import PackageRateInput from "./PackageRateInput";
import { CalendarViewFunctions } from '../PackageRates/Components/CalendarViewFunctions';
// import PackageRateCalendar from "./PackageRateCalendar";
// import CustomSelect from "../../CommonElements/CustomSelect";


const calendarViewFunctions = new CalendarViewFunctions()

function CustomPackageRates(packageId) {

    const { cityData, globalCityField, setShowApiLoader } =
    useContext(SharedDataContext);

    const [searchData, setSearchData] = useState("");
    const [tableData, setTableData] = useState([]);
    const [isToggled, setIsToggled] = useState(false)
    const [calendarData, setCalendarData] = useState([])
    const [tableHeaders, setTableHeaders] = useState([])
    const [packagesData, setPackagesData] = useState([])
    const [selectedPackage, setSelectedPackage] = useState({})
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);
    const [filterType, setFilterType] = useState("");
    const [filterData, setFilterData] = useState([]);
    const [isOpen, setIsOpen] = useState(false)
    const [editId, setEditId] = useState("")
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 30,
    });
    const [loader, setLoader] = useState(false);
    const onChangePage = (page) => {
        console.log("page", page);
        setPagination({
            ...pagination,
            pageIndex: page - 1
        });
    };

    const onChangeRowsPerPage = (currentRowsPerPage) => {
        setPagination({
            ...pagination,
            pageSize: currentRowsPerPage
        });
    };

    const onPackageNameClicked = (packageDetails) => {
        setSelectedPackage(packageDetails)
        setIsOpen(true)
    }

    const disableLoaders = () => {
        setLoader(false);
        // setShowApiLoader(false);
    };

    const onEditClick = (obj) => {
        setIsOpen(true)
        setEditId(obj.id)
    }

    useEffect(() => {
        if (!searchData && filterType != "search") {
            fetchTableData()
            return;
        }
        setPagination({
            pageIndex: 0,
            pageSize: 30,
        })
        fetchTableData()
    }, [searchData]);

    const toggleModal = () => {
        fetchTableData()
        setEditId("")
        setIsOpen(!isOpen)
    }

    const toggleBar = () => {
        setIsToggled(!isToggled)
        setSearchData("")
        setFilterType("")
        setPagination({
            pageIndex: 0,
            pageSize: 30,
        })
    }


    useEffect(()=>{
        fetchTableData(packageId);
    },[])

    const fetchTableData = (packageId) =>{

        let obj = {
            packageId:packageId
        }

        return getPackageRate(obj).then( async (result) =>{
            console.log("result is",result);
            // setPagin
            return result
        })

    }
    

  return (
    <div>

    </div>
  );

}
export default CustomPackageRates;